import { z } from 'zod';

export const IdeaRecipientCustomerSchema = z.object({
  id: z.number(),
  name: z.string(),
});

export const IdeaRecipientContactSchema = z.object({
  id: z.number(),
  email: z.string(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  customerId: z.number(),
});

export const GetIdeaRecipientsResponseSchema = z.object({
  customers: z.array(IdeaRecipientCustomerSchema),
  votersAndCommenters: z.array(IdeaRecipientContactSchema),
  contacts: z.array(IdeaRecipientContactSchema),
  totalCount: z.number(),
});

export type IdeaRecipientCustomerDto = z.infer<typeof IdeaRecipientCustomerSchema>;
export type IdeaRecipientContactDto = z.infer<typeof IdeaRecipientContactSchema>;
export type GetIdeaRecipientsResponseDto = z.infer<typeof GetIdeaRecipientsResponseSchema>;
